module.exports = __webpack_public_path__ + "static/media/MisFotosLogo.a15f908c.svg";